import { Injectable } from '@angular/core';
import * as componentActions from '@catdetails/actions/checklist';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {FileDownloadInfo} from '@catcore/types/common';
import {FileBlobResponse} from '@catcore/utils';

@Injectable()
export class ProjectChecklistService {

  constructor(private http: HttpClient,
              private store: Store<any>) {
  }

  setActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_CHK_ACTIVATE});
  }

  setInActive() {
    this.store.dispatch({type: componentActions.PROJECT_DETAILS_CHK_DEACTIVATE});
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/project-checklist/services/project-checklist.service.ts